import { render, staticRenderFns } from "./TextLinkList.vue?vue&type=template&id=11bdff3a&scoped=true&"
import script from "./TextLinkList.vue?vue&type=script&lang=js&"
export * from "./TextLinkList.vue?vue&type=script&lang=js&"
import style0 from "./TextLinkList.vue?vue&type=style&index=0&id=11bdff3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bdff3a",
  null
  
)

export default component.exports